var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('el-container',{staticClass:"main-el-container"},[_c('el-aside',{attrs:{"width":"200px"}},[_c('common-aside')],1),_c('el-container',{staticClass:"right-container"},[_c('el-header',[_c('common-header')],1),_c('common-Tag'),_c('el-main',{staticClass:"content-main"},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }